module.exports = "<div class=\"layout-column layout-align-center-center\"><div class=\"image-cropper\" [style.width.px]=\"width\" [style.height.px]=\"width\"><div class=\"user-image\" [style.width.px]=\"width\" [style.height.px]=\"width\"><img *ngIf=\"image\" src=\"{{imageUrl}}\" [attr.style]=\"imgStyle\"/></div></div><div class=\"text-footer text-center\" [class.ui-alt]=\"alt\" [style.margin-top.px]=\"textMargin\"> {{ text }}</div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/dynamic-image/dynamic-image.component.pug
// module id = 637
// module chunks = 0